export const heroImage =
  'https://cdn.magicpatterns.com/uploads/7BrmvAq85DKWNUGyTBT9BR/ChatGPT_Image_18_sept_2026,_23_25_19-Photoroom.webp'

/** Enlace de pago (Mercado Pago). */
export const checkoutUrl =
  'https://mega-pack-eduacion-fisica.impultienda.ar/checkout'
export const price = '$19.990'
export const fullPrice = '$144.900'
export const volumesValue = '$89.900'
export const bonusValue = '$55.000'
export const savings = '$124.910'
export const discountPercent = '86%'
export const currency = 'ARS'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '120', label: 'Sesiones completas' },
  { value: '6', label: 'Volúmenes estratégicos' },
  { value: '5', label: 'Bonos exclusivos' },
  { value: '∞', label: 'Acceso de por vida' },
]

export interface Proof {
  value: string
  label: string
}

export const proof: Proof[] = [
  { value: '2.500+', label: 'Docentes argentinos' },
  { value: '4.9/5', label: 'Calificación promedio' },
]

export const heroBadges: string[] = [
  'Pagá con Mercado Pago',
  'Acceso inmediato',
  '100% PDF imprimible',
  'Garantía de 7 días',
]

/** La realidad del docente de EF. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Domingos enteros diseñando unidades didácticas',
    detail: 'Y después nadie las lee. Tu tiempo libre se evapora.',
  },
  {
    title: 'Tus alumnos se aburren y sacás el balón de fútbol',
    detail: 'Salís del paso, pero la clase deja de enseñar algo.',
  },
  {
    title: 'El papeleo de las nuevas normativas te agobia',
    detail: 'Diseños Curriculares, competencias, informes… sin plantillas.',
  },
  {
    title: 'Llegás al patio cansado y sin progresión clara',
    detail: 'La clase arranca improvisada y se nota desde el primer minuto.',
  },
  {
    title: 'Los alumnos no mejoran de forma visible',
    detail: 'Sin coherencia de clase a clase no hay avance que se pueda medir.',
  },
  {
    title: 'No sabés cómo evaluar por competencias',
    detail: 'Las notas terminan siendo una impresión personal, no un dato.',
  },
]

/** Lo que incluye el acceso completo. */
export const included: string[] = [
  '6 volúmenes estratégicos',
  '120 sesiones completas',
  `5 bonos (valor ${bonusValue})`,
  'Adaptable a Primaria y Secundaria',
  'Acceso inmediato en PDF',
  'Acceso de por vida',
]

/** El cierre: lo que dejás de hacer y lo que ganás. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Sin domingos perdidos armando planificaciones', positive: false },
  { text: 'Sin clases improvisadas con el balón de fútbol', positive: false },
  { text: 'Sin evaluaciones subjetivas ni informes vagos', positive: false },
  { text: 'Sin buscar actividades sueltas en YouTube', positive: false },
  { text: 'Sin depender de material ni de presupuesto', positive: false },
  { text: 'Con tu año entero planificado desde el día 1', positive: true },
]
